// Screen 7 (spec 13 §Screens): `/c/{slug}/kpis/entry/numbers` (KPIs › data entry: managers
// and operators). Observations are `kpi`: with the add-on off the page says "not enabled" before
// any query.
import { createRoute } from "@tanstack/react-router";
import { NumbersForm } from "../features/entry/numbers-form";
import { useCompany, useFeature } from "../features/use-feature";
import { NotEnabledPage } from "../pages/status-pages";
import { DataEntryGate } from "../shell/mode-gate";
import { kpisRoute } from "./c.$slug.kpis";

export const numbersEntryRoute = createRoute({
  getParentRoute: () => kpisRoute,
  path: "entry/numbers",
  component: function NumbersEntry() {
    const { api } = numbersEntryRoute.useRouteContext();
    const company = useCompany();
    const kpi = useFeature("kpi");
    return (
      <DataEntryGate what="Number entry">
        {kpi.enabled ? (
          <NumbersForm api={api} company={company} />
        ) : (
          <NotEnabledPage
            what="Number entry"
            feature="kpi"
            companyName={company.name}
            slug={company.slug}
          />
        )}
      </DataEntryGate>
    );
  },
});
